interface CalendarBlankThinIconProps {
  className?: string;
  color?: string;
  strokeColor?: string;
  strokeWidth?: number;
}

const CalendarBlankThinIcon = ({
  className = "w-6 h-6",
  color = "#000000",
  strokeColor,
  strokeWidth = 0,
}: CalendarBlankThinIconProps) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.6875 3.23438H16.1719V2.15625C16.1719 2.06094 16.134 1.96953 16.0666 1.90213C15.9992 1.83474 15.9078 1.79688 15.8125 1.79688C15.7172 1.79688 15.6258 1.83474 15.5584 1.90213C15.491 1.96953 15.4531 2.06094 15.4531 2.15625V3.23438H7.54688V2.15625C7.54688 2.06094 7.50901 1.96953 7.44162 1.90213C7.37422 1.83474 7.28281 1.79688 7.1875 1.79688C7.09219 1.79688 7.00078 1.83474 6.93338 1.90213C6.86599 1.96953 6.82812 2.06094 6.82812 2.15625V3.23438H4.3125C4.02656 3.23438 3.75234 3.34796 3.55015 3.55015C3.34796 3.75234 3.23438 4.02656 3.23438 4.3125V18.6875C3.23438 18.9734 3.34796 19.2477 3.55015 19.4498C3.75234 19.652 4.02656 19.7656 4.3125 19.7656H18.6875C18.9734 19.7656 19.2477 19.652 19.4498 19.4498C19.652 19.2477 19.7656 18.9734 19.7656 18.6875V4.3125C19.7656 4.02656 19.652 3.75234 19.4498 3.55015C19.2477 3.34796 18.9734 3.23438 18.6875 3.23438ZM4.3125 3.95312H6.82812V5.03125C6.82812 5.12656 6.86599 5.21797 6.93338 5.28537C7.00078 5.35276 7.09219 5.39062 7.1875 5.39062C7.28281 5.39062 7.37422 5.35276 7.44162 5.28537C7.50901 5.21797 7.54688 5.12656 7.54688 5.03125V3.95312H15.4531V5.03125C15.4531 5.12656 15.491 5.21797 15.5584 5.28537C15.6258 5.35276 15.7172 5.39062 15.8125 5.39062C15.9078 5.39062 15.9992 5.35276 16.0666 5.28537C16.134 5.21797 16.1719 5.12656 16.1719 5.03125V3.95312H18.6875C18.7828 3.95312 18.8742 3.99099 18.9416 4.05838C19.009 4.12578 19.0469 4.21719 19.0469 4.3125V7.54688H3.95312V4.3125C3.95312 4.21719 3.99099 4.12578 4.05838 4.05838C4.12578 3.99099 4.21719 3.95312 4.3125 3.95312ZM18.6875 19.0469H4.3125C4.21719 19.0469 4.12578 19.009 4.05838 18.9416C3.99099 18.8742 3.95312 18.7828 3.95312 18.6875V8.26562H19.0469V18.6875C19.0469 18.7828 19.009 18.8742 18.9416 18.9416C18.8742 19.009 18.7828 19.0469 18.6875 19.0469Z"
        fill={color}
      />
    </svg>
  );
};

export default CalendarBlankThinIcon;
